import { render, staticRenderFns } from "./ArcadiaSidebar.vue?vue&type=template&id=2b85ae2b"
import script from "./ArcadiaSidebar.vue?vue&type=script&lang=js"
export * from "./ArcadiaSidebar.vue?vue&type=script&lang=js"
import style0 from "./ArcadiaSidebar.vue?vue&type=style&index=0&id=2b85ae2b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports